<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  },
  render(h) {
    return h(this.tag, {
      on: {
        click: () => this.$emit('tap')
      }
    }, this.$slots.default)
  }
}
</script>
